import Image from '@next/image'
import { Accordion as AccordionReach } from '@reach/accordion'
import { CustomAccordionItem } from 'components/Accordion/CustomAccordionItem'
import { Icon } from 'elements/Icon/Icon'
import { useTranslation } from 'react-i18next'
import { ImageType } from 'typings/image'

export type DownloadData = {
  headline: string
  categories: {
    title: string
    downloads: {
      title: string
      links: {
        thumbnail?: ImageType
        title: string
        url: string
        alt: string
        description: string
        data_type: string
        size: string
        filename: string
      }[]
    }[]
  }[]
}
type Props = { className: string; data: DownloadData }

export const DownloadModule = ({ className, data }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={`px-4 py-6 md:px-20 md:py-16 ${className}`}>
      <h2 className="mb-6 text-3xl font-medium text-black-light md:col-span-2">{data.headline}</h2>
      <AccordionReach collapsible multiple className="mt-6 w-full border-b border-gray sm:mt-10">
        {data.categories?.map((category) => (
          <CustomAccordionItem key={category.title} itemHeading={category.title}>
            <div className="py-2 px-4">
              {category.downloads.map((download) => (
                <div
                  key={download.title}
                  className="md:items-between mb-6 last-of-type:mb-0 md:flex md:flex-col md:justify-between"
                >
                  <h2 className="mb-2 text-base font-bold  md:mb-0">{download.title}</h2>
                  <ul className="flex flex-col justify-between md:my-4 md:justify-start">
                    {download.links?.map((link) => (
                      <li
                        key={link.title}
                        className={` flex w-full grid-cols-2 flex-col md:my-4 md:grid md:grid-rows-2 md:items-center md:text-center md:last-of-type:border-0`}
                      >
                        <h3
                          className={`col-start-1 row-start-1 mb-0 whitespace-nowrap text-xs font-bold leading-5 md:row-span-2  md:mr-10 md:pr-10 md:text-left md:text-base`}
                          // ${link.description ? 'md:row-span-1' : 'md:row-span-2'}
                        >
                          {link.title}
                        </h3>

                        {/* <p
                          className={`col-start-1 row-start-2 mb-0 text-xs font-normal leading-5 md:mr-10   md:text-left   md:text-base`}
                        >
                          {link.description}
                        </p> */}
                        <div className="my-5 flex h-full items-center justify-end md:col-start-2 md:row-span-2 md:my-0">
                          {link.url &&
                          ((link.filename && link.filename.includes('jpg')) ||
                            link.data_type.includes('Bild')) ? (
                            <div className="relative block h-12 w-9 ">
                              <Image
                                src={link.url}
                                alt={link.alt}
                                width={37}
                                height={50}
                                layout="responsive"
                                objectFit="cover"
                              />
                            </div>
                          ) : null}
                          {/* {link.data_type ||
                            (link.size && (
                              <p className="mb-0 flex h-full w-36 flex-col justify-center overflow-hidden truncate whitespace-nowrap border-r border-gray pr-5 text-xs font-normal leading-5 md:px-5 md:text-center">
                                <span>{link.data_type}</span>
                                {link.size && <span className="truncate">{link.size}</span>}
                              </p>
                            ))} */}
                          <a
                            href={link.url}
                            download
                            className={`font-base ml-4 flex h-full items-center justify-end border-l border-gray pl-4 font-bold uppercase text-red underline md:ml-10 md:pl-10`}
                          >
                            <Icon name="download" className="mr-2 text-red md:mr-4" />{' '}
                            {t('Download')}
                          </a>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </CustomAccordionItem>
        ))}
      </AccordionReach>
    </div>
  )
}
